import React from 'react';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const PageStyles = styled.div`
  padding: 16rem 0 10rem;
  min-height: 80vh;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 6rem;

  .label {
    font-size: 1.2rem;
    text-transform: uppercase;
    letter-spacing: 0.2rem;
    color: var(--highlight-blue);
    opacity: 0.7;
    margin-bottom: 0.8rem;
  }
  h1 {
    font-size: 4.8rem;
    font-family: 'Montserrat Bold';
    color: var(--gray-1);
    margin-bottom: 0.6rem;
  }
  .sub {
    font-size: 1.5rem;
    color: var(--gray-1);
    opacity: 0.45;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 2.4rem;
`;

const GameCard = styled(Link)`
  background: var(--deep-dark);
  border: 1px solid var(--gray-2);
  border-radius: 14px;
  padding: 3rem 2.4rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  transition: border-color 0.2s ease, transform 0.2s ease;

  &:hover {
    border-color: var(--highlight-blue);
    transform: translateY(-4px);
  }

  .card__icon {
    font-size: 3.6rem;
    line-height: 1;
  }
  .card__title {
    font-size: 2rem;
    font-family: 'Montserrat SemiBold';
    color: var(--gray-1);
  }
  .card__desc {
    font-size: 1.3rem;
    color: var(--gray-1);
    opacity: 0.5;
    line-height: 1.5;
  }
  .card__badge {
    align-self: flex-start;
    margin-top: auto;
    font-size: 1.1rem;
    padding: 0.3em 0.9em;
    border-radius: 20px;
    background: var(--highlight-blue);
    color: var(--dark-bg);
    text-transform: uppercase;
    letter-spacing: 0.06rem;
  }
`;

const ComingSoonCard = styled.div`
  background: var(--deep-dark);
  border: 1px dashed var(--gray-2);
  border-radius: 14px;
  padding: 3rem 2.4rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  opacity: 0.35;
  cursor: default;

  .card__icon { font-size: 3.6rem; line-height: 1; }
  .card__title {
    font-size: 2rem;
    font-family: 'Montserrat SemiBold';
    color: var(--gray-1);
  }
  .card__desc {
    font-size: 1.3rem;
    color: var(--gray-1);
    line-height: 1.5;
  }
  .card__badge {
    align-self: flex-start;
    margin-top: auto;
    font-size: 1.1rem;
    padding: 0.3em 0.9em;
    border-radius: 20px;
    border: 1px solid var(--gray-2);
    color: var(--gray-1);
    text-transform: uppercase;
    letter-spacing: 0.06rem;
  }
`;

const GAMES = [
  {
    to: '/games/dino',
    icon: '🦕',
    title: 'Dino Run',
    desc: "The classic Chrome offline runner. Jump over cacti, dodge pterodactyls, don't stop.",
    badge: 'Play Now',
  },
  {
    to: '/games/2048',
    icon: '🧩',
    title: '2048',
    desc: 'Slide the tiles, merge the numbers, reach 2048.',
    badge: 'Play Now',
  },
  {
    to: '/games/snake',
    icon: '🐍',
    title: 'Snake',
    desc: 'Eat the food, grow your snake. Don\'t hit the walls or yourself.',
    badge: 'Play Now',
  },
  {
    to: '/games/space-invaders',
    icon: '👾',
    title: 'Space Invaders',
    desc: 'Shoot down waves of alien invaders before they reach your ship.',
    badge: 'Play Now',
  },
];

const COMING_SOON = [
  { icon: '🏓', title: 'Pong', desc: 'Two paddles, one ball, endless rally.' },
];

export default function Games() {
  return (
    <PageStyles>
      <Helmet><title>Mini Arcade | Anas Qazi</title></Helmet>
      <div className="container">
        <Header>
          <p className="label">Mini Arcade</p>
          <h1>Games</h1>
          <p className="sub">A small corner of fun built into the portfolio</p>
        </Header>

        <Grid>
          {GAMES.map((g) => (
            <GameCard key={g.to} to={g.to}>
              <span className="card__icon">{g.icon}</span>
              <span className="card__title">{g.title}</span>
              <span className="card__desc">{g.desc}</span>
              <span className="card__badge">{g.badge}</span>
            </GameCard>
          ))}

          {COMING_SOON.map((g) => (
            <ComingSoonCard key={g.title}>
              <span className="card__icon">{g.icon}</span>
              <span className="card__title">{g.title}</span>
              <span className="card__desc">{g.desc}</span>
              <span className="card__badge">Coming Soon</span>
            </ComingSoonCard>
          ))}
        </Grid>
      </div>
    </PageStyles>
  );
}
